import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { ScarcityBlock } from './ScarcityBlock';
import { offerRows } from '../data/content';
export function Offer() {
  return <section id="offre" className="border-b border-line bg-night px-4 py-14 sm:px-6 sm:py-20" data-id="element-170" data-mp="1mpd4m18qnv5v">
      <SectionHeading eyebrow="L’offre" title="Tout ce système pourrait être vendu beaucoup plus cher" subtitle="Parce que vous n’achetez pas simplement des PDF. Vous obtenez un système qui peut vous éviter des années d’essais, d’erreurs et de doutes face au patient atteint d’une maladie rénale." data-id="element-171" data-mp="1hqs5641b9fih" />

      <div className="mx-auto mt-10 w-full max-w-xl overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-172" data-mp="yxeqzalthnpk">
        <div className="flex items-center justify-between border-b border-line px-5 py-3" data-id="element-173" data-mp="2fbemm9dmqr70">
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500" data-id="element-174" data-mp="2adwdoizm4bz0">
            Ce que vous recevez
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500" data-id="element-175" data-mp="pjz3fuxdlhys">
            Valeur
          </span>
        </div>
        <ul data-id="element-176" data-mp="zioccy7ans2w">
          {offerRows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 border-b border-line/70 px-5 py-3.5" data-id="element-177" data-mp="zj6e2acq6yi7">
              <span className="text-[14px] leading-snug text-slate-200" data-id="element-178" data-mp="6uipa4srpqzw">{row.label}</span>
              <span className="shrink-0 text-[14px] font-bold text-slate-400 line-through" data-id="element-179" data-mp="bsas3tuyaxiv">
                {row.value}
              </span>
            </li>)}
        </ul>
        <div className="flex items-center justify-between gap-4 bg-elevated px-5 py-4" data-id="element-180" data-mp="kl4cg5p98n3l">
          <span className="font-display text-[15px] font-bold text-white" data-id="element-181" data-mp="kmysp6pkzr1c">
            Valeur totale du système
          </span>
          <span className="font-display text-2xl font-extrabold text-slate-400 line-through" data-id="element-182" data-mp="3o9pjjoi9ad7h">
            292 €
          </span>
        </div>
      </div>

      <div className="mx-auto mt-8 w-full max-w-xl rounded-2xl border border-lime/40 bg-[#0C1810] p-6 text-center" data-id="element-183" data-mp="vdnxaqc2a5aa">
        <p className="text-[14px] leading-relaxed text-slate-300" data-id="element-184" data-mp="155k7v0vc3nve">
          Aujourd’hui, vous ne paierez ni 292 €. Ni 97 €.
        </p>
        <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-lime" data-id="element-185" data-mp="1067ctsub7ahq">
          Accès immédiat pour seulement
        </p>
        <p className="mt-2 font-display text-[68px] font-extrabold leading-none text-white sm:text-8xl" data-id="element-186" data-mp="ciz4t35hxnc0">
          19 €
        </p>
        <p className="mt-4 text-[14px] font-semibold leading-relaxed text-slate-300" data-id="element-187" data-mp="lhb6c07wi5j8">
          Paiement unique. Accès à vie. Aucun abonnement. Aucun coût caché.
        </p>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-line bg-ink px-3 py-2 text-[12px] font-medium text-slate-400" data-id="element-188" data-mp="hi292ldnjpix">
          <RefreshCwIcon className="h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-189" data-mp="1svwfeamo3ilg" />
          Le paiement s’effectue en euros — la conversion de devise est automatique.
        </p>

        <div className="mt-6" data-id="element-190" data-mp="25e9v8mqpr0x5">
          <CTAButton label="Je veux accéder à la Route Rénale™" caption="Téléchargement immédiat • Garantie de 7 jours • Accès à vie" data-id="element-191" data-mp="25ei6ybb3o06r" />
        </div>
      </div>

      <div className="mt-8" data-id="element-192" data-mp="1vgc7s1goh85l">
        <ScarcityBlock data-id="element-193" data-mp="1vhnbk1a4ifwp" />
      </div>
    </section>;
}